import { render, staticRenderFns } from "./SearchCol.vue?vue&type=template&id=700e1cd7"
import script from "./SearchCol.vue?vue&type=script&lang=ts"
export * from "./SearchCol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports